module.exports = __webpack_public_path__ + "static/media/Corsola_gaussian2.3a8640d4.png";